import moment from 'moment';

const defaultFormat = 'DD MMMM YYYY HH:mm';

moment.locale('id');
moment.defaultFormat = defaultFormat;

// Vue.prototype.$moment = moment;

export default moment;